import { dispatch, getState } from '@/store/store-helper';

export async function shouldRestrictUserAction(profileId?: string) {
  if (!profileId) return getState().common.index.isSpecial;

  const profileViewed = profileId ? await dispatch('actionProfileGetProfile', profileId) : null;
  const isProfileSpecial = getState()?.common?.index?.isSpecial ?? false;
  const isProfileViewedSpecial = profileViewed?.isSpecial;

  return profileViewed?.hasBlockedByUser || (isProfileSpecial && !isProfileViewedSpecial);
}
